import { render, staticRenderFns } from "./TestBlock.vue?vue&type=template&id=7b1117c6&"
import script from "./TestBlock.vue?vue&type=script&lang=js&"
export * from "./TestBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports